import useIntl from '@/hooks/useIntl';
import Guid from '@/services/Guid';
import { Row } from 'antd';
import { RuleObject } from 'antd/lib/form';
import { ReactNode } from 'react';
import Checkbox from './components/Checkbox';
import Datepicker from './components/DatePicker';
import Dropdown from './components/Dropdown';
import Number from './components/Number';
import Password from './components/Password';
import RadioGroup from './components/RadioGroup';
import Search from './components/Search';
import Select from './components/Select';
import Text from './components/Text';
import TextArea from './components/TextArea';
import Timepicker from './components/Timepicker';
import { Custom, Space } from './Customs';
import type { IField } from './data';

interface IProps {
    formFields: IField[];
    children?: (props: IField) => ReactNode;
    align?: 'top' | 'middle' | 'bottom' | 'stretch' | undefined;
    gutter?: number;
}

const renderFormItem = (component: string, props: IField) => {
    const items = {
        Input: <Text key={props.name} {...props} />,
        Select: <Select key={props.name || Guid.create()} {...props} />,
        DatePicker: <Datepicker key={props.name} {...props} />,
        TimePicker: <Timepicker key={props.name} {...props} />,
        InputNumber: <Number key={props.name} {...props} />,
        InputPassword: <Password key={props.name} {...props} />,
        Checkbox: <Checkbox key={props.name} {...props} />,
        RadioGroup: <RadioGroup key={props.name} {...props} />,
        Search: <Search key={props.name} {...props} />,
        Dropdown: <Dropdown key={props.name} {...props} />,
        TextArea: <TextArea key={props.name} {...props} />,
        Space: <Space key={props.name} {...props} />,
        Custom: <Custom key={props.name} {...props} />,
    };

    return items[component];
};

const FormRender: React.FC<IProps> = ({ formFields, align = 'top', gutter = 24, children }) => {
    const t = useIntl();
    return (
        <Row gutter={gutter} style={{ width: 'auto' }} align={align}>
            {formFields?.map((field: IField) => {
                if (field.customPhoneNumber) {
                    if (!children) {
                        throw new Error('You forgot to pass Phone Number component as children!');
                    }
                    return children({ ...field });
                }
                return renderFormItem(field.component, {
                    ...field,
                    rules: field.rules?.map((rule: RuleObject) => ({
                        ...rule,
                        message: t?.(rule.message),
                    })),
                    t,
                });
            })}
        </Row>
    );
};

export default FormRender;
